import React from 'react';
import { ArrowLeft, Play, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const Partenaires = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <div className="bg-black/95 border-b border-[#C9A55C]/20">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-[#C9A55C] hover:text-[#C9A55C]/80 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-6 py-16">
        {/* Title */}
        <div className="text-center mb-12">
          <span className="text-sm font-semibold tracking-[0.3em] uppercase text-[#C9A55C] mb-4 block">
            Partenaires
          </span>
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6">
            Nos <span className="text-[#C9A55C]">collaborations</span>
          </h1>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            Découvrez nos partenaires qui partagent nos valeurs d'accompagnement et de simplicité.
          </p>
        </div>

        {/* Video Section */}
        <div className="bg-[#0d0d0d] border border-[#C9A55C]/20 p-8 mb-12">
          <div className="flex items-center gap-3 mb-6">
            <Play className="w-6 h-6 text-[#C9A55C]" />
            <h2 className="text-2xl font-serif font-bold text-white">
              Comment obtenir vos 12 testeurs sur Play Store
            </h2>
          </div>

          {/* YouTube Embed */}
          <div className="relative w-full aspect-video mb-6">
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/TnQ4zsWK_n0"
              title="Comment obtenir vos 12 testeurs sur Play Store"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>

          {/* Description */}
          <div className="space-y-4 text-white/70">
            <p>
              Dans cette vidéo, découvrez comment éviter le casse-tête des 12 testeurs obligatoires 
              et réussir cette étape rapidement pour publier votre application Android.
            </p>
            
            <div className="space-y-2">
              <p className="text-[#C9A55C] font-semibold">Vous découvrirez :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Les difficultés des tests fermés sur le Play Store</li>
                <li>Une solution simple pour valider vos tests sans stress</li>
              </ul>
            </div>

            <div className="bg-[#C9A55C]/10 border border-[#C9A55C]/30 p-4 mt-6">
              <p className="text-[#C9A55C] font-semibold mb-2">
                Besoin d'aide pour vos 14 jours de test ?
              </p>
              <p className="text-white/70 mb-4">
                Un service clé en main pour gérer les 12 testeurs et vous faire gagner du temps.
              </p>
              <a
                href="https://wa.me/33651545460"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 font-semibold hover:bg-[#25D366]/90 transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
                Contact WhatsApp : +33 6 51 54 54 60
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="border-t border-[#C9A55C]/20 py-8">
        <div className="max-w-7xl mx-auto px-6 text-center text-white/50 text-sm">
          © 2026 HELP ADN - Tous droits réservés
        </div>
      </div>
    </div>
  );
};

export default Partenaires;
